import { render, staticRenderFns } from "./jobfairdetail.vue?vue&type=template&id=01be96a4&scoped=true"
import script from "./jobfairdetail.vue?vue&type=script&lang=js"
export * from "./jobfairdetail.vue?vue&type=script&lang=js"
import style0 from "./jobfairdetail.vue?vue&type=style&index=0&id=01be96a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01be96a4",
  null
  
)

export default component.exports